import { Project } from '@arra/core';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Link, Location, useLocation, useNavigate } from 'react-router-dom';
import { getProjectTitle } from '../../project/context/useProject';
import keyify from '../../project/parameters/keyify';
import { ReactComponent as HomeIcon } from '../../ui/icons/home.svg';
import { ReactComponent as NextIcon } from '../../ui/icons/next.svg';
import { IconContainer } from './Headers';

const textColor = "white";

const ProjectBreadcrumbWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const isPage = (location: Location) => {
  const isResults = location.pathname.includes('/results');
  const isActions = location.pathname.includes('/actions');
  const isProject = !isResults && !isActions;
  return { isResults, isActions, isProject };
};

export const ProjectBreadcrumb = ({ project }: { project: Project }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation(['project']);
  const projectTitle = getProjectTitle(
    project,
    t(`model:${keyify(project?.model.name)}.defaultTitle`),
  );

  const { isResults, isActions, isProject } = isPage(location);

  return (
    <ProjectBreadcrumbWrapper style={{ color: 'white' }}>
      <IconContainer onClick={() => navigate('/')}>
        <HomeIcon style={{ fill: textColor }} />
      </IconContainer>
      <IconContainer>
        <NextIcon style={{ fill: textColor, cursor: "auto" }} />
      </IconContainer>
      {isProject ? (
        <>
          <p className="h5b">{projectTitle}</p>
        </>
      ) : (
        <Link to={`/project/${project._id}`} className="h5r underline">
          {projectTitle}
        </Link>
      )}
      {isResults && (
        <>
          <IconContainer>
            <NextIcon style={{ fill: textColor, cursor: "auto"}}/>
          </IconContainer>
          <p className="h5b">{t('project:results-page.title')}</p>
        </>
      )}
      {isActions && (
        <>
          <IconContainer>
            <NextIcon style={{ fill: "white"}}/>
          </IconContainer>
          <p className="h5b">Actions</p>
        </>
      )}
    </ProjectBreadcrumbWrapper>
  );
};
